<template>
  <b-container fluid>
    <backlink />
    <h1>Affaires</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "BusinessList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
      // Codes société existants (business.company_code), chargés une fois pour le filtre.
      companyCodes: [],
    };
  },
  computed: {
    options: function () {
      return {
        // Plus d'agency_options : le filtre agence est passé en autocomplete, qui lit le
        // store directement (AgencyAutocomplete).
        status_options: this.$store.getters["status/getByGroup"]("business").selectOptions(
          "status_slug",
          "name"
        ),
        company_code_options: this.companyCodes.map((code) => ({ value: code, text: code })),
      };
    },
  },
  mounted() {
    this.$store.dispatch("agency/getAllForSelect");
    this.loadCompanyCodes();
  },
  methods: {
    /**
     * Codes société proposés au filtre. Il n'existe pas de référentiel : les valeurs sont
     * celles réellement portées par les affaires, lues côté serveur.
     */
    loadCompanyCodes() {
      this.$http
        .get(process.env.BACK_API_URL + "business/company_codes")
        .then((response) => {
          this.companyCodes = (response.data && response.data.company_codes) || [];
        })
        .catch(() => {
          // Le filtre reste vide : la liste des affaires, elle, s'affiche normalement.
          this.companyCodes = [];
        });
    },
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque 
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "business", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              agency: ctx.extended_filters_model.agency,
              statusSlug: ctx.extended_filters_model.status,
              manager: ctx.extended_filters_model.manager,
              companyCode: ctx.extended_filters_model.company_code,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.businesses || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Business/BusinessList.vue